import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { Pencil, Trash, X } from "lucide-react"; // Assuming you're importing these icons correctly
import { Permissions } from "../../../../permissions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 493,
  bgcolor: "background.paper",
  border: "2px solid #ffffff",
  boxShadow: 24,
  borderRadius: 2,
};

const BrandBox = () => {
  const [open, setOpen] = useState(false);
  const [state, setstate] = useState("");
  const [city, setcity] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  let editlocation =
    Permissions.find(permission => permission.includes("edit_location")) !==
    undefined;

  let deletelocation =
    Permissions.find(permission => permission.includes("delete_location")) !==
    undefined;

  return (
    <div className="flex flex-col box-border w-full border border-zinc-200 rounded-lg">
      <div className="flex flex-row box-border w-full rounded-lg mb-2">
        <div className="w-[30%] h-[100%] box-border flex items-center px-[3.220338983%] justify-center text-[1.9vh] font-medium font-outfit">
          City
        </div>
        <div className="w-[20%] h-[100%] box-border flex items-center px-[3.220338983%] justify-start text-[2.9vh] font-medium font-outfit">
          :
        </div>
        <div className="w-[50%] h-[100%] mt-3 box-border flex flex-row items-start justify-start pr-2">
          <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center font-semibold font-outfit">
            Indore
          </div>
        </div>
      </div>

      <hr className="border-[0.712px] border-zinc-200 w-[100%] mx-auto" />

      <div className="flex flex-row box-border w-full rounded-lg mb-2">
        <div className="w-[40%] h-[100%] box-border flex items-center px-[3.220338983%] justify-center text-[1.9vh] font-medium font-outfit">
          State
        </div>
        <div className="w-[10%] h-[100%] box-border flex items-center px-[3.220338983%] justify-start text-[2.9vh] font-medium font-outfit">
          :
        </div>
        <div className="w-[80%] h-[100%] mt-3 box-border flex flex-row items-start justify-start pr-2">
          <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center font-semibold font-outfit box-border">
            Madhya Pradhesh
          </div>
        </div>
      </div>

      <hr className="border-[0.712px] border-zinc-200 w-[100%] mx-auto" />

      <div className="flex flex-row box-border w-full rounded-lg mb-2">
        <div className="w-[60%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[1.9vh] font-medium font-outfit"></div>
        <div className="w-[40%] h-[100%] mt-3 box-border flex flex-row items-start justify-end pr-2">
          <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
            {editlocation ? (
              <button
                onClick={handleOpen}
                className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                <Pencil
                  color="#6750A4"
                  size={16}
                  className="mx-1 h-[16px] w-[16px]"
                />
              </button>
            ) : (
              <button
                onClick={handleOpen}
                className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#acacac1A] items-center justify-center">
                <Pencil
                  color="#acacac"
                  size={16}
                  className="mx-1 h-[16px] w-[16px]"
                />
              </button>
            )}

            {deletelocation ? (
              <button className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                <Trash color="red" className="mx-1 h-[16px] w-[16px]" />
              </button>
            ) : (
              <button className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#acacac1A] items-center justify-center">
                <Trash color="#acacac" className="mx-1 h-[16px] w-[16px]" />
              </button>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="flex flex-row box-border w-full border-b-[0.5px] border-zinc-600 my-2">
            <div className="w-[60%] h-[100%] box-border flex items-center py-2 px-[3.220338983%] justify-start text-[20px] font-medium font-outfit">
              Edit
            </div>
            <div className="w-[40%] h-[100%] mt-2 box-border flex flex-row items-start justify-end pr-2">
              <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
                <button
                  onClick={handleClose}
                  className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                  <X
                    color="#000"
                    size={18}
                    className="mx-1 h-[18px] w-[18px]"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-row items-start justify-start gap-x-4 box-border px-[2.083333vw] py-5">
            {/**
       *  <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
      <InputLabel id="demo-select-small-label">Sort by</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={city}
        label="Sort by"
        onChange={(e)=> {setcity(e.target.value)}}
      >
      <MenuItem value={10}>Sketchers</MenuItem>
      <MenuItem value={20}>Rebook</MenuItem>
      <MenuItem value={30}>Campus</MenuItem>
      <MenuItem value={40}>Sketchers</MenuItem>
      </Select>
    </FormControl>
       */}

            <TextField
              id="outlined-basic"
              label="City..."
              value={city}
              onChange={e => {
                setcity(e.target.value);
              }}
              variant="outlined"
              className="border-dotted border-2 border-green-400"
              size="small"
            />

            {/**
     * 
     *  <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
    <InputLabel id="demo-select-small-label">Sort by</InputLabel>
    <Select
      labelId="demo-select-small-label"
      id="demo-select-small"
      value={state}
      label="Sort by"
      onChange={(e)=> {setstate(e.target.value)}}
    >
    <MenuItem value={10}>Sketchers</MenuItem>
    <MenuItem value={20}>Rebook</MenuItem>
    <MenuItem value={30}>Campus</MenuItem>
    <MenuItem value={40}>Sketchers</MenuItem>
    </Select>
  </FormControl>
     */}
            <TextField
              id="outlined-basic"
              label="State..."
              value={state}
              onChange={e => {
                setstate(e.target.value);
              }}
              variant="outlined"
              className="border-dotted border-2 border-green-400"
              size="small"
            />
          </div>

          <hr className="border-[0.712px] border-zinc-200 w-[100%] mx-auto my-2" />

          <div className="flex flex-row mt-5 items-start justify-start mx-[1.522222vw] gap-x-3 pb-4">
            <button
              onClick={handleClose}
              className="border-[1px] border-zinc-300 rounded-md px-5 py-2 text-[2.2vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
              {" "}
              <span className="px- text-[#5652B0] px-3">Cancel</span>
            </button>
            <button
              onClick={handleClose}
              className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.2vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
              {" "}
              <span className="px-2 text-white ">Save</span>
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default BrandBox;
